import React, { Component } from 'react';
import { connect } from 'react-redux';

import GoogleInviteModal from 'components/google-invite-modal';

const InviteModal = class extends Component {
  render() {
    const { showGoogleInviteModal } = this.props;

    if (showGoogleInviteModal) {
      return <GoogleInviteModal />;
    }

    return null;
  }
};

const mapStateToProps = state => {
  const { google } = state;

  return {
    showGoogleInviteModal: google.show_invite_modal,
  };
};

export default connect(mapStateToProps, null)(InviteModal);
